const i18n = require("@/i18n");

module.exports = {
  id: "Stylable_StylableButton_3",
  preset: { rect: { width: 162, height: 75, x: 162, y: 75 }, tags: null },
  structure: {
    parent: "comp-knzvqsjj",
    style: {
      styleType: "custom",
      componentClassName: "wixui.StylableButton",
      style: {
        groups: {},
        properties: {
          "$st-css":
            ":import{\n    -st-from: 'wix-ui-santa/index.st.css';\n    -st-named: StylableButton\n}\n.root{\n    -st-extends: StylableButton;\n    transition: all 0.2s ease, visibility 0s;\n    padding: 3px;\n    box-shadow:; /*inset 3.54px 3.54px 0 -64px value(site_1_1)*/ background: #3F7652; border-radius: 50px; border: 0px solid rgb(63, 118, 82)\n}\n.root:hover{\n    background: #3F7652;\n    border: 0px solid rgb(63, 118, 82)\n}\n.root:hover::label{\n    color: #FFFFFF\n}\n.root:disabled{\n    background: #E2E2E2;\n    box-shadow: 0 0 0 rgba(0,0,0,0)\n}\n.root:disabled::label{\n    color: #8F8F8F\n}\n.root:disabled::icon{\n    fill: #8F8F8F\n}\n.root::container{\n    transition: inherit\n}\n.root::label{\n    transition: inherit;\n    margin: 0px 4px 0px 0px;\n    color: value(site_1_1);\n    font-weight: normal;\n    font-style: normal;\n    letter-spacing: 0.25em;\n    font-family: avenir-lt-w01_35-light1475496,sans-serif;\n    font-size: 15px\n}\n.root::icon{\n    transition: inherit;\n    margin: 0px 0px 0px 4px;\n    fill: value(site_1_1);\n    display: initial;\n    width: 37px;\n    height: 37px\n}\n.root:hover::icon{\n    fill: #FFFFFF;\n    width: 42px;\n    height: 42px\n}",
        },
        propertiesSource: { "$st-css": "value" },
      },
      pageId: "",
      compId: "",
      type: "ComponentStyle",
      metaData: {
        isHidden: false,
        sig: "4ie-24",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      skin: "wixui.skins.Skinless",
    },
    activeModes: {},
    data: {
      type: "StylableButton",
      metaData: {
        isHidden: false,
        sig: "mtq-2592",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      label: i18n.translate("buttons_text_preset_shop"),
      svgId: "6eea42305e4348869bdaf7b2d13b1bb5.svg",
    },
    components: [],
    componentType: "wixui.StylableButton",
    id: "comp-km0cnj36",
    layout: {
      x: 171,
      fixedPosition: false,
      y: 91,
      scale: 1,
      height: 45,
      rotationInDegrees: 0,
      width: 142,
    },
    type: "Component",
    props: {
      type: "StylableButtonProperties",
      metaData: { schemaVersion: "1.0", sig: "mtq-2556", pageId: "c1dmp" },
    },
    metaData: { sig: "4ie-18", pageId: "c1dmp" },
    skin: "wixui.skins.Skinless",
  },
};
